const BOT_TOKEN = '8015978985:AAG0KheFSSfum3TOvBCiwgA3Ls1pWauxbxk';

// Отправка текстового сообщения
export const sendTextMessage = async (chatId, text, parseMode) => {
  const response = await fetch(`https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      chat_id: chatId,
      text: text,
      parse_mode: parseMode,
      disable_web_page_preview: false,
      disable_notification: false
    })
  });
  return response.json();
};

// Отправка фото
export const sendPhotoMessage = async (chatId, file, caption, parseMode) => {
  const formData = new FormData();
  formData.append('chat_id', chatId);
  formData.append('photo', file);
  if (caption) {
    formData.append('caption', caption);
    formData.append('parse_mode', parseMode);
  }
  
  const response = await fetch(`https://api.telegram.org/bot${BOT_TOKEN}/sendPhoto`, {
    method: 'POST',
    body: formData
  });
  return response.json();
};

// Загрузка изображения на сервер
export const uploadImage = async (imageFile, setUploading, showNotification) => {
  if (!imageFile) return null;

  setUploading(true);
  
  try {
    const formData = new FormData();
    formData.append('file', imageFile);

    const response = await fetch('https://artdownload2-production.up.railway.app/upload?folder=course-images', {
      method: 'POST',
      body: formData
    });

    if (!response.ok) {
      throw new Error(`Ошибка загрузки: ${response.status}`);
    }

    const data = await response.json();
    return data.url || data.imageUrl || data.fileUrl;
    
  } catch (error) {
    console.error('Ошибка загрузки изображения:', error);
    if (showNotification) {
      showNotification('error', `Ошибка загрузки изображения: ${error.message}`);
    }
    return null;
  } finally {
    setUploading(false);
  }
};